const gap = '10px';

export const grid = {
  'with-grid-auto-1fr': {
    gridTemplateColumns: 'auto 1fr',
    gap,
  },
  'with-grid-2-auto-row': {
    gridTemplateRows: 'auto auto',
  },
  'with-grid-2-auto-col': {
    width: "100%",
    paddingY: 3,
    colGap: 3,
    gridTemplateColumns: ['auto', 'auto auto'],
    justifyContent: "space-between",
    alignItems: "center",
    textAlign: "left",
  }
};
